import { BETA_DSPIM_HOST, DSPIM_HOST } from '@/root/constants/common'

export const isDSPIMFunnel = (host?: string) => {
  if (host) {
    return !!(host.includes(BETA_DSPIM_HOST) || host.includes(DSPIM_HOST))
  }

  // Will work on client side only as window is used
  return !!(
    typeof window !== 'undefined' &&
    (window.location.host === BETA_DSPIM_HOST ||
      window.location.host === DSPIM_HOST)
  )
}
